import { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { Status } from "../../../client/status";
import { useAddItemToMenuClient } from "./addItemToCategoryClient";
import { useMenuData } from "../../../menu-provider/MenuDataProvider";
import { alertOptions } from "./alertOptions";
import { Box, IconButton, TextField } from "@mui/material";
import { NumericFormat } from "react-number-format";
import AddIcon from "@mui/icons-material/Add";

const isEmptyOrSpacesOnly = (value: string) => {
  return !value.replace(/\s/g, "").length;
};

export const AddItem = ({ categoryId }: { categoryId?: number }) => {
  const [itemName, setItemName] = useState<string>("");
  const [price, setPrice] = useState<string>("");

  const alert = useAlert();
  const { status, addItemToMenu } = useAddItemToMenuClient();
  const { reloadMenuData } = useMenuData();

  const isValid =
    categoryId !== undefined &&
    !isEmptyOrSpacesOnly(itemName) &&
    !!price &&
    price !== ".";

  const addItem = () => {
    const priceInNumber = parseFloat(price);
    if (
      categoryId == undefined ||
      isEmptyOrSpacesOnly(itemName) ||
      isNaN(priceInNumber)
    )
      return;
    addItemToMenu({ categoryId, itemName, price: priceInNumber });
  };

  useEffect(() => {
    if (status == Status.Success) {
      alert.success("Your menu has been updated!", alertOptions);
      reloadMenuData();
      setItemName("");
      setPrice("");
      return;
    }
    status == Status.Error && alert.error("Request failed", alertOptions);
  }, [status, alert, reloadMenuData]);

  return (
    <Box
      data-testid="test-id-category-select"
      display="flex"
      alignItems="center"
      gap={1}
    >
      <TextField
        variant="outlined"
        size="small"
        placeholder="Item name"
        value={itemName}
        onChange={(event) => setItemName(event.target.value)}
        onKeyDown={(e) => e.key === "Enter" && addItem()}
        fullWidth
        sx={{ "& .MuiOutlinedInput-root": { fontSize: 13 } }}
      />
      <NumericFormat
        customInput={TextField}
        value={price}
        onChange={(event) => setPrice(event.target.value)}
        placeholder="Price"
        allowNegative={false}
        variant="outlined"
        size="small"
        inputProps={{ inputMode: "decimal" }}
        sx={{
          width: 90,
          flexShrink: 0,
          "& .MuiOutlinedInput-root": { fontSize: 13 },
        }}
      />
      <IconButton
        data-testid="test-id-add-item-button"
        color="primary"
        onClick={addItem}
        disabled={!isValid}
        size="small"
        sx={{
          bgcolor: isValid ? "primary.main" : undefined,
          color: isValid ? "white" : undefined,
          borderRadius: 1,
          flexShrink: 0,
          "&:hover": { bgcolor: "primary.dark", color: "white" },
          "&.Mui-disabled": { bgcolor: "transparent" },
        }}
      >
        <AddIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};
